export { default as VolumeControls } from './component';
